import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Newsletter = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M5.94157 17.9729L7.43144 13.9483C7.76552 13.0459 8.62609 12.4468 9.58838 12.4468H22.1166C22.9995 12.4468 23.8044 12.9522 24.1881 13.7473L26.097 17.7032C26.4622 18.4601 26.3856 19.3558 25.8972 20.0397L24.987 21.3139C24.7094 21.7025 24.3177 21.9951 23.8664 22.151L14.8048 25.2814C14.3656 25.4331 13.8907 25.4482 13.4428 25.3248L8.00338 23.826C7.15158 23.5912 6.50953 22.8893 6.35148 22.02L5.83562 19.1828C5.76189 18.7773 5.79848 18.3594 5.94157 17.9729Z"
          fill="#99E538"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M7.86348 5.17758C7.96797 4.61587 8.47326 4.2 9.08405 4.2H22.8957C23.5125 4.2 24.0218 4.62421 24.121 5.19348C25.2514 11.6804 24.7854 19.1524 24.4832 22.462C24.4264 23.083 23.9063 23.5617 23.2539 23.5707L8.36215 23.7745C7.67269 23.7839 7.11833 23.2658 7.0851 22.6029C6.90965 19.1029 6.70969 11.3802 7.86348 5.17758Z"
          fill="white"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M5.6335 19.2822C5.39685 18.1778 6.58411 17.3178 7.55967 17.8869L14.6395 22.0168C15.4802 22.5072 16.5198 22.5072 17.3605 22.0168L24.3575 17.9352C25.3413 17.3613 26.5351 18.2401 26.2794 19.35L24.4495 27.2919C24.3135 27.8819 23.7882 28.3 23.1827 28.3H8.61683C8.00383 28.3 7.47413 27.8718 7.34569 27.2724L5.6335 19.2822Z"
          fill="#99E538"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M11.6099 8.71814C11.6247 8.56427 11.754 8.44683 11.9086 8.44683H20.0751C20.2317 8.44683 20.362 8.56731 20.3742 8.72345L20.5696 11.2235C20.5832 11.3978 20.4454 11.5468 20.2705 11.5468H11.6684C11.4914 11.5468 11.3529 11.3943 11.3698 11.2181L11.6099 8.71814Z"
          fill="#FFDB59"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 15.6999C21.3866 15.6999 21.7 15.3865 21.7 14.9999C21.7 14.6133 21.3866 14.2999 21 14.2999L10.9995 14.2999C10.6129 14.2999 10.2995 14.6133 10.2995 14.9999C10.2995 15.3865 10.6129 15.6999 10.9995 15.6999L21 15.6999ZM18 18.7C18.3866 18.7 18.7 18.3866 18.7 18C18.7 17.6134 18.3866 17.3 18 17.3H11C10.6134 17.3 10.3 17.6134 10.3 18C10.3 18.3866 10.6134 18.7 11 18.7H18Z"
          fill="#2B2F38"
        />
      </svg>
    )
  },
)

export default Newsletter
